module.exports = __webpack_public_path__ + "img/27.9d2d7746.png";